import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { process } from '@progress/kendo-data-query';
import {
    Grid, GridColumn as Column
} from '@progress/kendo-react-grid';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import BlockUi from '@availity/block-ui';
import Loaders from '../Loaders';

import * as TMService from "./statusHistory.service.js";
import './StatusHistory.scss';
import wrongImg from "../../src/images/wrong.png";
import rightImage from "../../src/images/right.png";
import whiteImage from "../images/white.png";

import { MDBCol, MDBContainer, MDBRow } from 'mdbreact';

class StatusHeader extends React.Component {
    render() {
        return (
            <a className="k-link" onClick={this.props.onClick}>
           
            <span className="headerClass">{this.props.title}</span>
                {this.props.children}
            </a>
        );
    }
  }
class StatusHistory extends React.Component {

    state = {statusData : [],tor_id : "",userDetails : [],blocking : false};

async getStatus(tor_id)
{

    var FOObj 		=	{};
	var FOArray 	=	[];
    FOObj["TOR_ID"]		=	tor_id;
    // FOObj["TOR_ID"]	=	"6000000782";
    //  FOArray.push (FOObj);
    const response = await TMService.getStatusData(FOObj);
    if(response != null)
    {
        var responseDocStatus = response.docStatus;
        for(var i =0 ;i<responseDocStatus.length;i++)
        {
            if(responseDocStatus[i].date == "0000-00-00")
            {
                responseDocStatus[i].date = "";
            }
    
            if(responseDocStatus[i].time == "00:00:00")
            {
                responseDocStatus[i].time = "";
            }
        }
        this.setState({statusData : responseDocStatus,blocking : false});
    }

}

   componentDidMount()
   {
       this.setState({blocking : true});
    let profile = JSON.parse(sessionStorage.getItem('profile'));
      var tor_id = this.props.foData != null ? this.props.foData.tor_id : "";
       //var tor_id = "6000000782";
       this.setState({tor_id : tor_id , userDetails :profile});
       console.log("torData" +tor_id);
       if(tor_id == null)
       {
        this.setState({statusData : []});
       }
       else
    this.getStatus(tor_id);
    
   }

   
    render() {
        
  
        return (
            <div>
        <BlockUi tag="div" blocking={this.state.blocking}
            loader={<Loaders />}> 
        
            <MDBContainer fluid>
                <MDBRow>
                  
                    <Grid
        ScrollMode="scrollable"
        style={{ height: "600px", width: 'auto'}}
        data={this.state.statusData}     
      
        sortable={true}
        pageable={true}
        pageSize={20}
    >
        <Column title="Status No" field="statusNo" width="100px" headerCell={StatusHeader} />
        <Column title="Status Description" field="statusDescription" width="350px" headerCell={StatusHeader} />
        <Column title="Completed By" field ="completedBy" width="150px"  headerCell={StatusHeader}/>
        <Column title="Approver" field = "arBy" width="180px"  headerCell={StatusHeader} />
        <Column title="Date" field="date" width="100px" headerCell={StatusHeader}  />
        <Column title="Time" field = "time" width="100px"  headerCell={StatusHeader}/>
        <Column title="Comments" field="comment" headerCell={StatusHeader} />
        <Column field="Status" title = "Status" width ="100px" headerCell={StatusHeader}   cell= {props => (
            <td>
                <div align="center">
                { props.dataItem.status== "Y" &&   <span className="white-space:pre">
                    <img className="footer-icon" src= {rightImage}  className ="gridImg" />
                        </span>}
                       { props.dataItem.status== "N" && <span class="white-space:pre">
                            <img className="footer-icon" src= {wrongImg}  className="gridImg" />
                            </span>}
                          { props.dataItem.status== "" && <span class="white-space:pre">
                                <img className="footer-icon" src= {whiteImage} className="gridImg" />
                                </span>
        }
                                </div>
            </td>
        )} />
    </Grid>

                    
                </MDBRow>
            </MDBContainer>
            </BlockUi>
            </div>
        );
    }
}
export default StatusHistory;

